module.exports = __webpack_public_path__ + "static/media/1.024d5e3b.jpg";